import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ID_ESTADO_ENTREGADO } from '../../constants/pedidoEstados'
import * as publicacionesService from '../servicios/publicacionesService'
import LinkButton from '../ui/LinkButton'
import styles from './DetallePie.module.css'

const PUBLICACION_ESTADO_PUBLICADA = 2
const DetallePie = ({ idPublicacion, setReclamo, esVentas, idEstadoPedidoItem }) => {
  const [mostrar, setMostrar] = useState(false)

  const fetchData = async () => {
    if (!esVentas && idPublicacion !== null) {
      const { data } = await publicacionesService.buscarPorId(idPublicacion)
      setMostrar(data.idPublicacionEstado === PUBLICACION_ESTADO_PUBLICADA)
    }
  }

  useEffect(() => {
    fetchData()
  }, [esVentas, idPublicacion])

  return (
    <div className={styles.detallePie}>
      {!esVentas && idPublicacion !== null && mostrar && (
        <LinkButton className={styles.btnSuccess} to={`/Publicacion/${idPublicacion}`}>
          Volver a Comprar
        </LinkButton>
      )}
      {!esVentas && idPublicacion !== null && idEstadoPedidoItem === ID_ESTADO_ENTREGADO && (
        <button type="button" className={styles.btnDanger} onClick={() => setReclamo(true)}>
          Reclamar!
        </button>
      )}
    </div>
  )
}

export default DetallePie

DetallePie.propTypes = {
  idPublicacion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setReclamo: PropTypes.func.isRequired,
  esVentas: PropTypes.bool,
  idEstadoPedidoItem: PropTypes.number.isRequired
}
